import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "color"];
import { ChartDonut, NULL_COLOR } from './ChartDonut';
import { jsx as _jsx } from "react/jsx-runtime";
const FULL_VALUE = 100;
export const ChartDonutPercentage = _ref => {
  let {
      value: providedValue,
      color
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const value = Math.min(providedValue, FULL_VALUE);
  const data = [{
    value,
    color
  }, {
    value: FULL_VALUE - value,
    color: NULL_COLOR
  }];
  return /*#__PURE__*/_jsx(ChartDonut, Object.assign({}, rest, {
    data: data
  }));
};